/* src/app/views/display/components/modals/edit-specific-date-time-modal/date-time-window-form/date-time-window-form.component.scss */
.remove-window-button {
  display: flex;
  align-self: center;
}
.remove-window-button:hover {
  cursor: pointer;
  background-color: #dadbde;
}
/*# sourceMappingURL=date-time-window-form.component.css.map */
